import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-right",
  showConfirmButton: false,
  timer: 2500,
  background: "var(--Tre-color)",
  color: "var(--Sec-color)",
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export const confirmDialog = Swal.mixin({
  showCancelButton: true,
  confirmButtonColor: "#3085d6",
  cancelButtonColor: "#d33",
  confirmButtonText: "Yes",
  showClass: {
    popup: `
      animate__animated
      animate__fadeInUp
      animate__faster
    `,
  },
  hideClass: {
    popup: `
      animate__animated
      animate__fadeOutDown
      animate__faster
    `,
  },
});

export const showSuccessNotification = (title, body, toast) => {
  toast.current.show({
    severity: "info",
    summary: title,
    detail: body,
    life: 15000,
  });
};
// const SwalMixin = {
//   methods: {
//     showSuccess(title, text) {
//       Swal.fire({
//         title: title,
//         text: text,
//         icon: "success",
//         confirmButtonText: "Cool",
//         timer: 3000,
//       });
//     },
//     showError(title, text) {
//       Swal.fire({
//         title: title,
//         text: text,
//         icon: "error",
//         confirmButtonText: "Cool",
//         timer: 3000,
//       });
//     },
//     showWarning(title, text) {
//       Swal.fire({
//         title: title,
//         text: text,
//         icon: "warning",
//         confirmButtonText: "Cool",
//         timer: 3000,
//       });
//     },
//     showInfo(title, text) {
//       Swal.fire({
//         title: title,
//         text: text,
//         icon: "info",
//         confirmButtonText: "Cool",
//         timer: 3000,
//       });
//     },
//   },
// };
export default Toast;
